export const LOCAL_NETWORK_FRESHNESS_MS = 90_000;

export type WebAvailability = {
  probedThisLaunch: boolean;
  onLocalNetwork: boolean | null;
  registered: true;
};

export type AvailabilitySource = {
  isStandinDeployment: boolean;
  lastSuccessfulPull: (orgToken: string) => number | undefined;
};

export function isStandinDeploymentOrigin(source: AvailabilitySource): boolean {
  return source.isStandinDeployment === true;
}

export function webAvailability(
  orgToken: string,
  source: AvailabilitySource,
  nowMs: number
): WebAvailability {
  const lastPull = source.lastSuccessfulPull(orgToken);
  const probedThisLaunch = lastPull !== undefined;

  if (!isStandinDeploymentOrigin(source)) {
    return { probedThisLaunch, onLocalNetwork: false, registered: true };
  }

  if (lastPull === undefined) {
    return { probedThisLaunch: false, onLocalNetwork: null, registered: true };
  }

  return {
    probedThisLaunch: true,
    onLocalNetwork: nowMs - lastPull <= LOCAL_NETWORK_FRESHNESS_MS,
    registered: true,
  };
}
